<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="value"
        @input="v => $emit('input', v)"
        @click:clear="v => $emit('input', null)"
        :label="label"
        :prepend-icon="icon"
        readonly
        :clearable="clearable"
        :rules="rules"
        :outlined="outlined"
        :hide-details="hideDetails"
        :solo="solo"
        :solo-inverted="soloInverted"
        :filled="filled"
        :dense="dense"
        :suffix="suffix"
        :class="{ 'no-before': filled }"
        v-on="readonly ? false : on"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="menu"
      :value="value"
      @change="v => $emit('input', v)"
      @click:minute="
        () => {
          menu = false;
          $refs.menu.save();
        }
      "
      no-title
      scrollable
    ></v-time-picker>
  </v-menu>
</template>

<script>
export default {
  name: "TimePicker",
  props: {
    label: {
      type: String,
      default: ""
    },
    suffix: {
      type: String,
      default: ""
    },
    value: {
      required: true
    },
    icon: {
      type: String,
      default: "event"
    },
    required: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    allowedDates: {
      default: null
    },
    firstDayOfWeek: {
      default: 0
    },
    month: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    solo: {
      type: Boolean,
      default: false
    },
    soloInverted: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rules() {
      if (this.required === true) {
        return [v => !!v || `${this.label} est requis`];
      } else {
        return [() => true];
      }
    }
  },
  data() {
    return {
      menu: false
    };
  }
};
</script>

<style></style>
